import { render, staticRenderFns } from "./DxGrid.vue?vue&type=template&id=7e635c61&"
import script from "./DxGrid.vue?vue&type=script&lang=js&"
export * from "./DxGrid.vue?vue&type=script&lang=js&"
import style0 from "./DxGrid.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports